module.exports = __webpack_public_path__ + "fonts/AudiType-WideNormal_4.03.191d9403.woff2";